import React, {Component} from 'react'; 
import moment from 'moment'; 
import FlipMove from 'react-flip-move'; 
import './tweet.css'; 

export class Tweets extends Component {


    renderTweets = () =>
    {
        const { tweets } = this.props
       
        return tweets.map((tweet, i) => 
        {
        const hideImage = tweet.media_url==="";
        return (
        <div className="tweet" key={tweet.twid}>  
                <div className="tweet--user">
                    <img className="tweet--user-avatar" src={tweet.avatar} alt="" />
                    <div className="tweet--user-name">{tweet.author}<span>@{tweet.screenname}</span></div>
                </div>
                <div style={{marginTop:'20px', paddingBottom:'15px'}}><p className="tweet--body">{tweet.body}</p>
                {!hideImage && <img  className="tweet--image" src={tweet.media_url} alt="" />}</div>
                <div className="tweet--time">{moment(tweet.date).locale('fr').format("LLLL")}</div>
        </div>)}
        
    )} 
    

    render()
    {
        return (
            <FlipMove duration={750} enterAnimation="elevator" leaveAnimation="elevator"> 
                {this.renderTweets()}
            </FlipMove>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Tweets/index.js